var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E37400",
    d: "M13.2,20.9822184 L13.2,36.4804479 C13.2,40.0021225 15.632039,41.9644368 18.2071392,41.9644368 C20.5914912,41.9644368 23.2142784,40.2953967 23.2142784,36.4804479 L23.2142784,21.2206527 C23.2142784,17.9922523 20.8299264,15.9750981 18.2071392,15.9750981 C15.584352,15.9750981 13.2,18.1996901 13.2,20.9822184 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AB00",
    d: "M26.313936,5.0071203 L26.313936,36.4804479 C26.313936,40.0021225 28.745975,41.9644368 31.3210752,41.9644368 C33.7054272,41.9644368 36.3282144,40.2953967 36.3282144,36.4804479 L36.3282144,5.2455546 C36.3282144,2.01715418 33.9438624,0 31.3210752,0 C28.698288,0 26.313936,2.22459202 26.313936,5.0071203 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.093,
    cy: 36.957,
    fill: "#E37400",
    rx: 5.007,
    ry: 5.007
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/Google_Analytics.9b1fc48d.svg";
export { ForwardRef as ReactComponent };